import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const FlowerIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			fillRule="evenodd"
			clipRule="evenodd"
			d="M7.68933 1.51171C7.88459 1.31645 8.20117 1.31645 8.39644 1.51171L10.2929 3.40815H12.5429C12.819 3.40815 13.0429 3.63201 13.0429 3.90815V6.15817L14.9393 8.05462C15.1346 8.24988 15.1346 8.56647 14.9393 8.76173L13.0429 10.6582V12.9082C13.0429 13.1843 12.819 13.4082 12.5429 13.4082H10.2929L8.39644 15.3046C8.20117 15.4999 7.88459 15.4999 7.68933 15.3046L5.79288 13.4082H3.54288C3.26674 13.4082 3.04288 13.1843 3.04288 12.9082V10.6582L1.14645 8.76173C0.951184 8.56647 0.951183 8.24988 1.14645 8.05462L3.04288 6.15818V3.90815C3.04288 3.63201 3.26674 3.40815 3.54288 3.40815H5.79289L7.68933 1.51171ZM8.04297 11.4083C9.69982 11.4083 11.043 10.0651 11.043 8.40823C11.043 6.75137 9.69982 5.40823 8.04297 5.40823C6.38611 5.40823 5.04297 6.75137 5.04297 8.40823C5.04297 10.0651 6.38611 11.4083 8.04297 11.4083Z"
		/>
	</svg>
))
